import React from 'react';
import './filtersWrapper.css';
import { useDispatch, useSelector } from "react-redux";
import { filterWindowAction } from "../../redux/rootReducer";

const FiltersWrapper = ({ style, children }) => {
    const dispatch = useDispatch();

    const filterWindow = useSelector(state => state.filterWindow);
    const filterUser = useSelector(state => state.filterUser);
    const filterUsers = useSelector(state => state.filterUsers);
    const giftsStatusFilterOptions = useSelector(state => state.giftsStatusFilterOptions);
    const filterTypesOptions = useSelector(state => state.filterTypesOptions);
    const filterCoachesOptions = useSelector(state => state.filterCoachesOptions);
    const filterOneTimeWorkout = useSelector(state => state.filterOneTimeWorkout);
    const filterDate = useSelector(state => state.filterDate);
    const filterMinSum = useSelector(state => state.filterMinSum);
    const filterMaxSum = useSelector(state => state.filterMaxSum);
    const filterPaymentMethodsOptions = useSelector(state => state.filterPaymentMethodsOptions);
    const filterSubjectOptions = useSelector(state => state.filterSubjectOptions);
    const filterDebtWorkouts = useSelector(state => state.filterDebtWorkouts);
    const filterConstraintsOptions = useSelector(state => state.filterConstraintsOptions);
    const filterWorkoutsCountOptions = useSelector(state => state.filterWorkoutsCountOptions);

    return (
        <div className="flt" style={ style }>
            <div
                className={ `button button--blue flt__button ${
                    filterUsers.without_subscriptions === '1'
                    || filterUsers.expire_to
                    || filterUsers.registration_not_later
                    || filterUsers.workouts_less_than
                    || filterUsers.not_been_x_months
                    || filterUsers.birthday_from
                    || filterUsers.birthday_to
                    || filterUser?.user?.id
                    || giftsStatusFilterOptions.some(el => el.active)
                    || filterTypesOptions.some(el => el.active)
                    || filterCoachesOptions.some(el => el.active)
                    || filterConstraintsOptions.some(el => el.active)
                    || filterWorkoutsCountOptions.some(el => el.active)
                    || filterOneTimeWorkout === '1'
                    || filterDebtWorkouts === '1'
                    || filterDate.to || filterDate.from
                    || filterMaxSum || filterMinSum
                    || filterPaymentMethodsOptions.some(el => el.active)
                    || filterSubjectOptions.some(el => el.active)
                        ? 'flt__button--active' : ''
                }` }
                onClick={ () => dispatch(filterWindowAction(!filterWindow)) }
            >Фильтры</div>
            <div className={ `flt__wrapper ${ filterWindow && 'flt__wrapper--open' }` }>
                { children }
            </div>
        </div>
    );
};

export default FiltersWrapper;